<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý Công nợ', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <date-range
          title="Quản lý công nợ"
          v-model="daterange"
          class="mx-1"
        ></date-range>
        <div class="ml-2 mr-2">
          <hr />
          <b-row>
            <b-col>
              <b-button block v-b-toggle.advSearch variant="primary">
                <i class="fa fa-binoculars"></i> Tìm kiếm nâng cao
              </b-button>
            </b-col>
            <b-col>
              <b-button @click="printDebt" block variant="success">
                <i class="fa fa-print"></i> In toàn bộ
              </b-button>
            </b-col>
            <b-col>
              <download-excel
                class="btn btn-primary btn-block"
                :data="debtTables"
                :fields="debtFields"
                :worksheet="worksheet"
                name="cong-no.xls"
              >
                <i class="fa fa-file-export"></i>
                Xuất file Excel
              </download-excel>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse id="advSearch" class="mt-2">
                <b-card>
                  <b-row>
                    <b-col md="4">
                      <base-input v-model="searcAdv.search" label="Từ khóa">
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        v-model="searcAdv.customer"
                        label="Khách hàng"
                        :ajaxData="getCustomer"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        label="Người phụ trách"
                        v-model="searcAdv.user"
                        :ajaxData="getUser"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div class="d-flex">
                            <span class="avatar avatar-sm rounded-circle mr-2">
                              <img
                                v-holder="{
                                  img: '40x40',
                                  text: item.name
                                }"
                                @error="$imgHolder"
                                :alt="item.name"
                                :src="$mediaURI + item.avatar"
                              />
                            </span>
                            <div>
                              <strong>{{ item.name }}</strong>
                              <br />
                              <span>{{ item.phone }}</span>
                            </div>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="12">
                      <hr />
                      <b-button @click="fetchData" block variant="secondary ">
                        <i class="fa fa-search"></i> Tìm kiếm</b-button
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <template v-if="debts.length > 0">
          <b-card
            class="mb-3 m-2"
            no-body
            v-for="(item, index) in debts"
            :key="index"
          >
            <b-card-header
              header-tag="header"
              class="p-1 d-flex justify-content-between align-items-center"
            >
              <b-button variant="link" href="#" v-b-toggle="item.key">
                <span>{{ item.month }}</span>
              </b-button>
            </b-card-header>
            <b-collapse visible :id="item.key">
              <b-card-body class="px-2">
                <div
                  class="timeline timeline-one-side"
                  data-timeline-content="axis"
                  data-timeline-axis-style="dashed"
                >
                  <div
                    v-for="(item, index) in item.customers"
                    :key="index"
                    class="timeline-block"
                  >
                    <span class="timeline-step badge-success">
                      <span class="avatar avatar-sm rounded-circle">
                        <img
                          v-holder="{
                            img: '40x40',
                            text: item.info.name
                          }"
                          @error="$imgHolder"
                          :alt="item.info.name"
                          :src="$mediaURI + item.info.avatar"
                        />
                      </span>
                    </span>
                    <div
                      class="timeline-content"
                      style="width:auto; max-width:unset"
                    >
                      <h5 class="mb-2">
                        {{ item.info.code }} - {{ item.info.name }} - Người phụ
                        trách : {{ item.info.userManage.name }}
                      </h5>
                      <template v-for="(cur, i) in item.currencys">
                        <div
                          :key="i"
                          style="min-height: 95px; margin-bottom:20px"
                          class="table-responsive base-table table-soft b-table-sticky-header"
                        >
                          <table
                            class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                          >
                            <thead>
                              <tr>
                                <th>STT</th>
                                <th>Ngày tạo</th>
                                <th class="text-left">Mã Phiếu xuất</th>
                                <th class="text-left">Người Tạo phiếu</th>
                                <th class="text-right">Tổng tiền</th>
                                <th class="text-right">Đã thanh toán</th>
                                <th class="text-right">Còn lại</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, index) in item.data"
                                :key="index"
                              >
                                <template v-if="row.currency == cur.currency">
                                  <td class="bg-info text-light col-fix ">
                                    {{ index + 1 }}
                                  </td>
                                  <td class="text-left">
                                    {{ $dateUnix(row.dateCreated) }}
                                  </td>
                                  <td class="text-left">{{ row.code }}</td>
                                  <td class="text-left">
                                    {{ row.userCreated.name }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(row.total) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(row.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(row.total - row.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                </template>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="4">Tổng cộng</td>
                                <td class="text-right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </td>
                                <td class="text-right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </td>
                                <td class="text-right">
                                  {{
                                    $formatNumber(
                                      cur.summarry.total - cur.summarry.paid
                                    )
                                  }}
                                  {{ cur.currency }}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </template>
        <b-card v-else class="m-2">
          <h4>Chưa có công nợ nào trong khoản thời gian này</h4>
        </b-card>
      </block>
    </div>
    <preview ref="preview"></preview>
  </div>
</template>
<script>
import { receiptService, userService, customerService } from "@/_services";
import { addDateTime, formatDateUnix } from "@/utils/date";
import JsonExcel from "vue-json-excel";

import { mapState } from "vuex";

import Preview from "./__Preview";
export default {
  name: "debt-manage-cp",
  components: {
    Preview,
    downloadExcel: JsonExcel
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        from: addDateTime(-3),
        to: new Date()
      },
      searcAdv: {
        search: "",
        customer: "",
        user: ""
      },
      daterange: {},
      debtTables: [],
      worksheet: "Công nợ",
      debtFields: {
        STT: "stt",
        "Mã khách hàng": "customer.code",
        "Tên khách hàng": "customer.name",
        "Mã phiếu xuất": "code",
        "Người tạo phiếu": "userCreated.name",
        "Tổng tiền": "total",
        "Đã thanh toán": "paid",
        "Còn lại": {
          callback: value => {
            return `${value.total - value.paid}`;
          }
        },
        "Loại tiền": "currency",
        "Ngày tạo": {
          callback: value => {
            return this.$dateUnix(value.dateCreated);
          }
        }
      },
      lastIndexCustomerSelected: 0,
      debts: [],
      fields: [],
      allCurrency: []
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  methods: {
    fetchData() {
      this.listQuery.from = this.daterange.from;
      this.listQuery.to = this.daterange.to;
      if (this.searcAdv.user) {
        this.listQuery.userId = this.searcAdv.user.id;
      } else {
        this.listQuery.userId = "";
      }
      if (this.searcAdv.customer) {
        this.listQuery.customerId = this.searcAdv.customer.id;
      } else {
        this.listQuery.customerId = "";
      }

      this.listQuery.search = this.searcAdv.search;

      this.worksheet = `${this.$date(
        this.daterange.from,
        "DD_MM_YYYY"
      )} - ${this.$date(this.daterange.to, "DD_MM_YYYY")}`;
      this.allCurrency = [];
      receiptService.debt(this.listQuery).then(res => {
        let receipts = res.data.data;
        this.debtTables = [];
        let debt = [];
        let stt = 1;
        receipts.forEach(element => {
          let code = element.customer.code;
          let month = formatDateUnix(element.dateCreated, "MM_YYYY");
          // debugger;
          this.allCurrency[element.currency] = element.currency;
          if (debt[month] && debt[month].customers) {
            let customers = debt[month].customers;

            if (customers[code] && customers[code].data) {
              customers[code].data.push(element);
              // if (!customers[code].currencys.includes(element.currency)) {
              let currency = this.checkItemInArray(
                customers[code].currencys,
                element.currency,
                "currency"
              );
              if (!currency || currency == false) {
                //if (!customers[code].currencys[element.currency]) {
                let currencySummarry = {
                  currency: element.currency,
                  summarry: {
                    total: element.total,
                    paid: element.paid
                  }
                };
                customers[code].currencys.push(currencySummarry);
                //customers[code].currencys.push(element.currency);
              } else {
                currency.summarry.total += element.total;
                currency.summarry.paid += element.paid;
              }
            } else {
              //let customers = [];
              let currencySummarry = {
                currency: element.currency,
                summarry: {
                  total: element.total,
                  paid: element.paid
                }
              };

              customers[code] = {
                info: element.customer,
                code: code,
                data: [element],
                currencys: [currencySummarry]
                //currencys: [element.currency]
              };
            }
            // debt[month].data.push(element);
          } else {
            let customers = [];
            let currencySummarry = {
              currency: element.currency,
              summarry: {
                total: element.total,
                paid: element.paid
              }
            };

            customers[code] = {
              info: element.customer,
              code: code,
              data: [element],
              currencys: [currencySummarry]
              //currencys: [element.currency]
            };
            debt[month] = {
              customers: customers,
              key: month,
              date: element.dateCreated,
              month: formatDateUnix(element.dateCreated, "MM/YYYY")
            };
          }
          element.stt = stt;
          stt++;
          this.debtTables.push(element);
        });
        this.debts = Object.values(debt);
        this.debts.forEach(element => {
          element.customers = Object.values(element.customers);
        });
        console.log(this.debts, this.allCurrency);
      });
    },
    checkItemInArray(arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element[key] == value) {
          return element;
        }
      }
      return false;
    },
    getUser(keyword, cb) {
      userService.adminGetAllUser({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push(this.info);
        data.push({
          id: -1,
          name: "Tất cả nhân viên"
        });
        cb(data);
      });
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push({
          id: -1,
          name: "Tất cả khách hàng"
        });
        cb(data);
      });
    },
    printDebt() {
      this.$refs.preview.visible = true;
      let debt = {
        from: this.daterange.from,
        to: this.daterange.to,
        data: this.debts
      };
      this.$refs.preview.setData(debt);
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log("context menu", a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert("help");
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    }
  },
  watch: {
    daterange: function() {
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
